import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { PortalAirportNode, PortalTripType } from '@app/services/api/api.types';

@Component({
  selector: 'trip-item',
  templateUrl: './trip-item.component.html',
  styleUrls: ['./trip-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TripItemComponent {
  @Input() from: string;
  @Input() departureAirport?: PortalAirportNode;
  @Input() arrivalAirport?: PortalAirportNode;
  @Input() tripType?: PortalTripType;
  @Input() departureAt?: string;
  @Input() roundTripDepartureAt?: string;
  @Input() totalPassengers?: number;
  @Input() minimalOptionPrice?: number;
  @Input() optionCount?: number;
  @Input() maximalSecureSavings?: number;

  @HostBinding('class.inplace') @Input() inplace: boolean;
}
